<template>
    <div class="poster">
        <canvas id="canvasContent" class="canvas-content" width="375" height="812"></canvas>
        <div class="flex poster-box" v-if="posterUrl">
            <div class="flex img-poster-box">
                <div class="img-poster-layer" @click="close"></div>
                <img class="img-poster" :src="posterUrl" />
            </div>
        </div>
        <!-- 海报正在生成 -->
        <div class="flex loading" v-show="!posterUrl">
            <div class="flex loading_img">
                <img src="https://oss01.dayou.art/1301d03be573998f5c6e88ece68c4ecb.gif" />
            </div>
            <div class="loading_text">正在生成海报图</div>
        </div>

        <div class="layer" @click="close"></div>
    </div>
</template>

<script>
import { qrcode } from "@/api/preview.js";
export default {
    data () {
        return {
            QRcode: '', // 二维码base64图片
            posterUrl: '', // 转让海报图片路径
        }
    },
    mounted () {
        this.get_qrcode()
        .then(() => this.merge_transfer_poster())
    },
    methods: {
        close () {
            this.$emit('close')
        },

        //获取二维码
        get_qrcode() {
            return qrcode({}).then((res) => {
                // console.log(res.qr_code)
                this.QRcode = res.qr_code;
            });
        },

        // 合并海报图片
		merge_transfer_poster () {
            const that = this
            const ele = document.getElementById('canvasContent')
            const ctx = ele.getContext('2d') // canvas执行上下文
            const imgs = [
                'https://oss01.dayou.art/interior-invitation-poster.png',
            ]
            // 总宽高
            const screenWidth = 375
            const screenHeight = 812

            // 背景图
            const img1 = new Image()
            img1.src = `${imgs[0]}?v=${Math.random()}` // 添加一个随机查询字符串来避免跨域
            img1.crossOrigin = 'Anonymous'
            img1.onload = function () {
                ctx.drawImage(img1, 0, 0, screenWidth, screenHeight)

                // 二维码
                const img2 = new Image()
                img2.src = `${that.QRcode}` // 添加一个随机查询字符串来避免跨域
                img2.crossOrigin = 'Anonymous'
                img2.onload = function () {
                    ctx.drawImage(this, 148, 620, 78, 78)
                    setTimeout(() => {
                        that.get_posterUrl()
                    })
                }
            }
		},

        get_posterUrl () {
            const ele = document.getElementById('canvasContent')
            this.posterUrl = ele.toDataURL("image/png");
        },
    },
}
</script>

<style lang="less" scoped>
@import "./poster.less";
</style>
